import { curatedBlogPostsQuery } from '@benniehealth/core-js/helpers/contentful';

import { isProd } from '@app/helpers/environment';
import { cmsClient } from '@app/helpers/requests/client';
import { responseDataAdapter } from '@app/helpers/requests/bennieFetch';

export const fetchBlogPosts = ({ queryParams }) => {
  const query = curatedBlogPostsQuery(
    queryParams,
    !isProd(window.location.hostname),
  );

  return cmsClient
    .post(`/blog-content`, { query })
    .then(response => responseDataAdapter(response));
};
